import React, {useEffect} from 'react'
import './Acebank.css'
import Androidscreenshoot from '../images/Acebank/Androidscreenshoot.png'
import Artboard1 from '../images/Acebank/Artboard1.png'
import Artboard2 from '../images/Acebank/Artboard2.png'
import Artboard3 from '../images/Acebank/Artboard3.png'
import Artboard4 from '../images/Acebank/Artboard4.png'
import Artboard5 from '../images/Acebank/Artboard5.png'
import Artboard6 from '../images/Acebank/Artboard6.png'
import Artboard7 from '../images/Acebank/Artboard7.png'
import Artboard8 from '../images/Acebank/Artboard8.png'
import Artboard9 from '../images/Acebank/Artboard9.png'

import Artboard11 from '../images/Acebank/Artboard11.png'
import Artboard12 from '../images/Acebank/Artboard12.png'
import Artboard13 from '../images/Acebank/Artboard13.png'

import Footer from '../Component/footer'

 /* import Artboard7 from '../images/Acebank/Artboard7.png'
     import Artboard23 from '../images/Acebank/Artboard23.png'
import Artboard24 from '../images/Acebank/Artboard24.png'
import Artboard25 from '../images/Acebank/Artboard25.png'
import Artboard26 from '../images/Acebank/Artboard26.png'
import Artboard27 from '../images/Acebank/Artboard27.png'
import Artboard28 from '../images/Acebank/Artboard28.png' */



function Acebank() {
    useEffect(() => {
        window.scroll(0, 0);
        document.body.scrollTop = 0;
    }, []);

    return (
        <div>
       
        <div className="imagevh" id="imageAndroidscreenshoot"><img src={Androidscreenshoot} height="" width="100%" alt=""/></div>
        
        <div className="project-details-Acebank">
        <div className="client-role-Acebank">
            <h4 className="client-project-Acebank">CLIENT</h4>
            <h2 className="portfolio-heading-Acebank1"> Acebank</h2>
            <h4 className="role-Acebank">
            ROLE
            </h4>
            <h2 className="portfolio-role-Acebank2">UX Designer</h2>
           </div>
            <h4 className="client-details-Acebank"> DETAILS
            </h4>
            <p className="client-details-Acebank-p">
            Acebank is a service that makes it easy for people to use money.

That means, you may pay all of your utility bills, internet 
bills, mobile phone bills, and much more with a single tap on your smartphone.
            </p>

            <p className="client-details-Acebank-p2">
            The goal is to make financial transactions between individuals 
            and businesses as simple, safe, and dependable as feasible.

            </p>
         </div>


         <div className="imagevh" id="artboard"><img src={Artboard1} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard2} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard3} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard4} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard5} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard6} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard7} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard8} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard9} height="auto" width="100%" alt=""/></div>
       
         <div className="imagevh" id="artboard"><img src={Artboard11} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard12} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard13} height="auto" width="100%" alt=""/></div>
         
    {/*
        <div className="imagevh" id="artboard"><img src={Artboard7} height="auto" width="100%" alt=""/></div>
        <div className="imagevh" id="artboard"><img src={Artboard23} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard24} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard25} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard26} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard27} height="auto" width="100%" alt=""/></div>
    <div className="imagevh" id="artboard"><img src={Artboard28} height="auto" width="100%" alt=""/></div> */}
         
     <div className="imagevh" id="artboard" ><Footer /></div> 

        </div>
        
    )
}


export default Acebank
